import { defineStore } from 'pinia'
import BodegasService from '../services/bodegas.service'
import { useStore } from 'vuex'
const _BodegasService = new BodegasService()

export const useBodegasStore = defineStore('bodegasStore', {
  state: () => ({
    listado_bodegas: [],
    bodega_seleccionada: ''
  }),
  getters: {
    _listado_bodegas: state => state.listado_bodegas,
    _bodega_seleccionada: state => state.bodega_seleccionada
  },
  actions: {
    obtenerListadoBodegas () {
      _BodegasService.listarBodegasTodas().then(({ data }) => {
        const array = []
        for (const i of data) {
          array.push({
            ...i,
            name: i.WhsCode + ' - ' + i.WhsName
          })
        }
        this.listado_bodegas = array
      })
    },
    obtenerListadoBodegasByUser () {
      const store = useStore()
      const user = store.getters['auth/user']
      _BodegasService.bodegasUsuario(user.user_id, { tipoBodega: 1 }).then(({ data }) => {
        const array = []
        for (const i of data) {
          array.push({
            ...i,
            WhsCode: i.idBodega,
            name: i.idBodega + ' - ' + i.bodega.WhsName
          })
        }
        this.listado_bodegas = array
      })
    }
  }
})
